<mat-card appearance="outlined" *appRoles="['Usuarios.Listar']">
  <mat-card-header>
    <div class="header-nombre-nuevo">
      <h2>Calendario Judicial</h2>
      <app-button-new (click)="openDialog({ accion: accionesDialog.Agregar})"></app-button-new>
    </div>
  </mat-card-header>
  <!-- Contenido de filtros -->
  <mat-card-content>
    <form [formGroup]="formFilter">
      <div class="row">
        <!-- Fecha (Rango) -->
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Fecha</mat-label>
            <mat-date-range-input [rangePicker]="fechaPicker">
              <input matStartDate placeholder="Desde" [formControl]="formFilter.get('FechaDesde')" />
              <input matEndDate placeholder="Hasta" [formControl]="formFilter.get('FechaHasta')" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="fechaPicker"></mat-datepicker-toggle>
            <mat-date-range-picker #fechaPicker></mat-date-range-picker>
          </mat-form-field>
        </div>

        <!-- Motivo -->
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Motivo</mat-label>
            <input matInput type="text" formControlName="Motivo" />
          </mat-form-field>
        </div>

        <!-- Es Hábil -->
        <div class="col-6 col-md-4 col-lg-2">
          <mat-checkbox formControlName="EsHabil">Es Hábil</mat-checkbox>
        </div>

        <!-- Es Feriado -->
        <div class="col-6 col-md-4 col-lg-2">
          <mat-checkbox formControlName="EsFeriado">Es Feriado</mat-checkbox>
        </div>

        <!-- Es Feria Judicial -->
        <div class="col-6 col-md-4 col-lg-2">
          <mat-checkbox formControlName="EsFeriaJudicial">Es Feria Judicial</mat-checkbox>
        </div>

        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spBusquedaJurisdicciones" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Jurisdicciones </mat-label>
            <mat-select placeholder="Seleccione opcion" multiple formControlName="IdsJurisdiccion">
              <mat-option [value]="jurisdiccion.id" *ngFor="
                  let jurisdiccion of jurisdicciones;
                  let i = index;
                  trackBy: trackByItems
                ">
                {{ jurisdiccion.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spBusquedaFueros" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Fueros </mat-label>
            <mat-select placeholder="Seleccione opcion" multiple formControlName="IdsFuero">
              <mat-option [value]="fuero.id" *ngFor="
                  let fuero of fueros;
                  let i = index;
                  trackBy: trackByItems
                ">
                {{ fuero.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>


        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spBusquedaJuzgados" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Juzgados </mat-label>
            <mat-select placeholder="Seleccione opcion" multiple formControlName="IdsJuzgado">
              <mat-option [value]="juzgado.id" *ngFor="
                  let juzgado of juzgados;
                  let i = index;
                  trackBy: trackByItems
                ">
                {{ juzgado.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Horario -->
        <div class="col-sm-12 col-md-6 col-lg-1" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Horario Desde</mat-label>
            <input matInput type="time" formControlName="HorarioDesde" />
          </mat-form-field>
        </div>

        <div class="col-sm-12 col-md-6 col-lg-1" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Horario Hasta</mat-label>
            <input matInput type="time" formControlName="HorarioHasta" />
          </mat-form-field>
        </div>

        <!-- Fecha Alta -->
        <!-- <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Fecha Alta</mat-label>
            <mat-date-range-input [rangePicker]="altaPicker">
              <input matStartDate placeholder="Desde" [formControl]="formFilter.get('FechaAltaDesde')" />
              <input matEndDate placeholder="Hasta" [formControl]="formFilter.get('FechaAltaHasta')" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="altaPicker"></mat-datepicker-toggle>
            <mat-date-range-picker #altaPicker></mat-date-range-picker>
          </mat-form-field>
        </div> -->

        <!-- Fecha Modificación -->
        <!-- <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Fecha Modificación</mat-label>
            <mat-date-range-input [rangePicker]="modPicker">
              <input matStartDate placeholder="Desde" [formControl]="formFilter.get('FechaModificacionDesde')" />
              <input matEndDate placeholder="Hasta" [formControl]="formFilter.get('FechaModificacionHasta')" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="modPicker"></mat-datepicker-toggle>
            <mat-date-range-picker #modPicker></mat-date-range-picker>
          </mat-form-field>
        </div> -->
      </div>

      <div class="row align-items-center">
        <div class="col-auto">
          <div style="display: flex; align-items: center; gap: 8px;">
            <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
            <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
          </div>
        </div>
        <div class="col-auto">
          <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
            Filtros Avanzados
          </mat-slide-toggle>
        </div>
        <div class="col-auto">
          <mat-button-toggle-group appearance="legacy" name="filtroFechas" aria-label="Rango de fechas"
            (change)="cambiarRangoFechas($event.value)">
            <mat-button-toggle value="hoy">Hoy</mat-button-toggle>
            <mat-button-toggle value="semana">Semana</mat-button-toggle>
            <mat-button-toggle value="mes">Mes</mat-button-toggle>
            <mat-button-toggle value="anio">Año</mat-button-toggle>
          </mat-button-toggle-group>

        </div>
      </div>
    </form>
  </mat-card-content>


  <mat-card-content>
    <mat-divider></mat-divider>
    <ngx-spinner [zIndex]="100" name="spCalendarioJudicial" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>

    <!-- Inicio Contenedor acciones tabla -->
    <div class="contenedor-acciones-tablas">
      <div class="acciones-tabla">
        <!-- Boton de Acciones -->
        <!-- <app-button-action></app-button-action> -->
      </div>
      <mat-form-field appearance="outline" *ngIf="data" class="buscador-tabla">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input />
      </mat-form-field>
    </div>
    <!-- Fin Contenedor acciones tabla -->

    <div *ngIf="data">
      <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" matSort matSortStart="asc">
        <!-- Fecha -->
        <ng-container matColumnDef="fecha">
          <mat-header-cell *matHeaderCellDef mat-sort-header><strong>Fecha</strong></mat-header-cell>
          <mat-cell *matCellDef="let dia">
            {{ dia.fecha | date: 'dd/MM/yyyy' }}
          </mat-cell>
        </ng-container>

        <!-- Motivo -->
        <ng-container matColumnDef="motivo">
          <mat-header-cell *matHeaderCellDef><strong>Motivo</strong></mat-header-cell>
          <mat-cell *matCellDef="let dia">
            {{ dia.motivo }}
          </mat-cell>
        </ng-container>

        <!-- Hábil -->
        <ng-container matColumnDef="esHabil">
          <mat-header-cell *matHeaderCellDef><strong>Hábil</strong></mat-header-cell>
          <mat-cell *matCellDef="let dia">
            <mat-icon matTooltip="Es día hábil" color="primary" *ngIf="dia.esHabil">check_circle</mat-icon>
            <mat-icon matTooltip="No es día hábil" color="warn" *ngIf="!dia.esHabil">cancel</mat-icon>
          </mat-cell>
        </ng-container>

        <!-- Feriado -->
        <ng-container matColumnDef="esFeriado">
          <mat-header-cell *matHeaderCellDef><strong>Feriado</strong></mat-header-cell>
          <mat-cell *matCellDef="let dia">
            <mat-icon matTooltip="Es feriado" color="primary" *ngIf="dia.esFeriado">event</mat-icon>
          </mat-cell>
        </ng-container>

        <!-- Feria Judicial -->
        <ng-container matColumnDef="esFeriaJudicial">
          <mat-header-cell *matHeaderCellDef><strong>Feria Judicial</strong></mat-header-cell>
          <mat-cell *matCellDef="let dia">
            <mat-icon matTooltip="Es feria judicial" color="accent" *ngIf="dia.esFeriaJudicial">gavel</mat-icon>
          </mat-cell>
        </ng-container>

        <!-- Jurisdicción -->
        <ng-container matColumnDef="jurisdiccion">
          <mat-header-cell *matHeaderCellDef><strong>Jurisdicción</strong></mat-header-cell>
          <mat-cell *matCellDef="let dia">
            {{ dia.jurisdiccion?.descripcion }}
          </mat-cell>
        </ng-container>

        <!-- Fuero -->
        <ng-container matColumnDef="fuero">
          <mat-header-cell *matHeaderCellDef><strong>Fuero</strong></mat-header-cell>
          <mat-cell *matCellDef="let dia">
            {{ dia.fuero?.descripcion }}
          </mat-cell>
        </ng-container>

        <!-- Juzgado -->
        <ng-container matColumnDef="juzgado">
          <mat-header-cell *matHeaderCellDef><strong>Juzgado</strong></mat-header-cell>
          <mat-cell *matCellDef="let dia">
            {{ dia.juzgado?.descripcion }}
          </mat-cell>
        </ng-container>

        <!-- Accion Column -->
        <ng-container matColumnDef="accion">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            <strong>Acción</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let empresaUsuario" class="action-link">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Ver, entidad: empresaUsuario })"
                *appRoles="['Usuarios.Ver']">
                <mat-icon>visibility</mat-icon>
                <span>Ver</span>
              </button>
              <div *ngIf="empresaUsuario.activo">

                <button mat-menu-item
                  (click)="openDialog({ accion: accionesDialog.Modificar, entidad: empresaUsuario })"
                  *appRoles="['Usuarios.Modificar']">
                  <mat-icon>edit</mat-icon>
                  <span>Editar</span>
                </button>


                <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Eliminar, entidad: empresaUsuario })"
                  *appRoles="['Usuarios.Eliminar']">
                  <mat-icon>delete</mat-icon>
                  <span>Eliminar</span>
                </button>
              </div>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row matRipple *matRowDef="let row; columns: displayedColumns"></mat-row>
      </table>

      <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="20"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
      </mat-paginator>
    </div>
    <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>
  </mat-card-content>
</mat-card>
